import { required } from 'AppReact/schema';

export default {
  card_id: required('integer'),
  make_ready_category_id: required('integer'),
  is_assigned: required('boolean'),
  is_scheduled: required('boolean'),
  is_complete: required('boolean'),
}
